/**
 * @fileoverview GET handler for the "/engagement/campaigns/push_buttons_for_campaign" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsPushButtonsForCampaign } from "./constants";
import type { EngagementCampaignsPushButtonsForCampaignResult } from "./types";

export const getEngagementCampaignsPushButtonsForCampaign = reactQueryFetcherAdapter(
  engagementCampaignsPushButtonsForCampaign,
  (
    signal: AbortSignal,
    campaignId: string,
    appGroupId: string,
    query: string
  ): Promise<EngagementCampaignsPushButtonsForCampaignResult> => {
    return fetch(
      "/engagement/campaigns/push_buttons_for_campaign",
      "GET",
      { selected_campaign_id: campaignId, app_group_id: appGroupId, query },
      { signal }
    );
  }
);
